import React, { useState, useEffect, useRef } from "react";
import { ThemeCtx, ToastCtx, api, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination } from "../shared.js";

export function PageAPIConfig({user}){
  var T=React.useContext(ThemeCtx).T;
  var _cfg=useState([]); var cfg=_cfg[0]; var setCfg=_cfg[1];
  var _editing=useState({}); var editing=_editing[0]; var setEditing=_editing[1];
  var _msg=useState({text:"",type:""}); var msg=_msg[0]; var setMsg=_msg[1];
  var _saving=useState(null); var saving=_saving[0]; var setSaving=_saving[1];
  var showMsg=function(text,type){setMsg({text,type});setTimeout(function(){setMsg({text:"",type:""});},4000);};
  useEffect(function(){api.get("/config").then(setCfg).catch(function(){});},[]);
  var saveKey=async function(key){
    var val=editing[key];
    if(val===undefined) return;
    setSaving(key);
    try{
      await api.request("/config/"+key,{method:"PUT",body:JSON.stringify({value:val})});
      setCfg(function(p){return p.map(function(c){return c.key===key?Object.assign({},c,{value:c.is_secret&&val?"••••••••":val}):c;});});
      setEditing(function(p){var n=Object.assign({},p);delete n[key];return n;});
      showMsg(key+" saved — applied immediately","success");
    }catch(e){showMsg(e.message,"error");}
    setSaving(null);
  };
  var reloadAll=async function(){
    try{var d=await api.post("/config/reload",{});showMsg("Reloaded "+d.reloaded+" values","success");}
    catch(e){showMsg(e.message,"error");}
  };
  var iStyle={flex:1,padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,borderRadius:8,color:T.text,fontSize:13,outline:"none",minWidth:0};
  var KEYS=["AI_PROVIDER","ANTHROPIC_API_KEY","AWS_REGION","AWS_ACCESS_KEY_ID","AWS_SECRET_ACCESS_KEY"];
  return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:14}},
    msg.text&&React.createElement("div",{style:{background:msg.type==="success"?T.success+"22":T.danger+"22",border:"1px solid "+(msg.type==="success"?T.success:T.danger)+"44",borderRadius:8,padding:"10px 14px",fontSize:13,color:msg.type==="success"?T.success:T.danger}},msg.text),
    React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,borderRadius:10,padding:"16px"}},
      React.createElement("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}},
        React.createElement("div",{style:{fontSize:13,fontWeight:600,color:T.text}},"API Configuration"),
        React.createElement("button",{onClick:reloadAll,style:{background:T.inset,color:T.text2,border:"1px solid "+T.border,borderRadius:6,padding:"6px 12px",cursor:"pointer",fontSize:12}},"Reload All")
      ),
      React.createElement("div",{style:{fontSize:12,color:T.text3,marginBottom:14}},"Changes apply to the running server immediately. No restart needed."),
      KEYS.map(function(key){
        var item=cfg.find(function(c){return c.key===key;});
        if(!item) return null;
        var isEditing=editing[key]!==undefined;
        var currentVal=isEditing?editing[key]:item.value;
        return React.createElement("div",{key:key,style:{marginBottom:14}},
          React.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginBottom:4}},
            React.createElement("div",{style:{fontSize:11,color:T.text3,textTransform:"uppercase",letterSpacing:.5,fontWeight:600}},key),
            item.is_secret&&React.createElement("span",{style:{fontSize:10,color:T.warning,background:T.warning+"22",borderRadius:4,padding:"1px 6px"}},"SECRET")
          ),
          React.createElement("div",{style:{fontSize:11,color:T.text3,marginBottom:4}},item.description),
          React.createElement("div",{style:{display:"flex",gap:6}},
            key==="AI_PROVIDER"
              ?React.createElement("select",{value:currentVal||"none",onChange:function(e){var v=e.target.value;setEditing(function(p){var n=Object.assign({},p);n[key]=v;return n;});},style:iStyle},
                ["none","anthropic","bedrock"].map(function(v){return React.createElement("option",{key:v,value:v},v);})
               )
              :React.createElement("input",{type:item.is_secret?"password":"text",value:currentVal||"",onChange:function(e){var v=e.target.value;setEditing(function(p){var n=Object.assign({},p);n[key]=v;return n;});},placeholder:item.is_secret?"Enter to update":"",style:iStyle}),
            React.createElement("button",{onClick:function(){saveKey(key);},disabled:!isEditing||saving===key,style:{background:isEditing?T.accent:T.inset,color:isEditing?"#fff":T.text3,border:"1px solid "+(isEditing?T.accent:T.border),borderRadius:8,padding:"8px 14px",cursor:"pointer",fontSize:12,fontWeight:600,flexShrink:0,opacity:saving===key?0.6:1}},saving===key?"Saving...":"Save")
          )
        );
      })
    )
  );
}

